import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';
import { isDp3Policy } from 'common/source/utilities/policyInfoHelper';
import { CurrentUserService } from 'services/currentUser';

const module = angular.module('add-items-to-policy-card', []);

interface AddItemsToPolicyCardController extends angular.IStrictController {
    icon: string;
    description: string;
    reason: ContactReason;
}

module.component('addItemsToPolicyCard', {
    template: template,
    controller: function(
        this: AddItemsToPolicyCardController,
        $element: angular.IAugmentedJQuery,
        $stateParams: PolicyStateParams,
        currentUserService: CurrentUserService
    ) {
        this.$onInit = () => {
            this.icon = 'stamp';
            this.description = 'Need to add items to your policy?';
            this.reason = 'add-items';

            const policyId = $stateParams.policyIndex;
            currentUserService.getCustomerPolicyInfoByIndex(policyId).then((policyInfo) => {
                if (isDp3Policy(policyInfo)) {
                    $element.addClass('ng-hide');
                }
            });
        };
    }
});

export { module };
